import React from 'react';
import { m } from 'framer-motion';
import { XIcon, CheckIcon } from 'lucide-react';
import { PrimaryButton } from '../ui/PrimaryButton';
import { SectionTag } from '../ui/SectionTag';
import { ScrollHintTable } from '../ui/ScrollHintTable';
import { scrollToId } from '../../utils/scroll';
import { transformationRows, transformationFooterStats } from '../../data/transformation';
export function Transformation() {
  return <section className="bg-white py-10 sm:py-14" data-id="element-223" data-mp="2ffdpkivf2uhn">
      <div className="mx-auto max-w-4xl px-4 text-center sm:px-6" data-id="element-224" data-mp="2bfbuisk6szbc">
        <SectionTag icon="⚡" data-id="element-225" data-mp="2bh6hecf0r1i2">La transformación</SectionTag>
        <h2 className="mt-5 font-heading text-3xl font-bold uppercase leading-tight text-azul sm:text-4xl" data-id="element-226" data-mp="26nbocidixa6b">
          Tus domingos no deberían terminar así...
        </h2>
        <p className="mt-4 text-base leading-relaxed text-muted sm:text-lg" data-id="element-227" data-mp="2z4eazx334m49">
          Terminas la semana y todavía tienes que preparar el próximo entrenamiento. Buscas ejercicios en
          YouTube, guardas algunas ideas y terminas improvisando una sesión sin saber si realmente responde
          a lo que necesita tu equipo.
        </p>

        <div className="mt-6 rounded-2xl border border-naranja/30 bg-naranja/5 p-5 text-left sm:p-6" data-id="element-228" data-mp="1a5y7qz8ytlid">
          <p className="font-heading text-sm font-semibold uppercase tracking-wide text-naranja" data-id="element-229" data-mp="wfcwnwpr6fv1">
            Recupera tus domingos
          </p>
          <p className="mt-2 text-sm leading-relaxed text-muted sm:text-base" data-id="element-230" data-mp="mhorecuitpym">
            Deja de reunir ejercicios desde cero: parte de una sesión organizada y ajusta el objetivo, los
            grupos y la dificultad.
          </p>
        </div>
      </div>

      <div className="mx-auto mt-8 max-w-4xl px-4 sm:px-6" data-id="element-231" data-mp="diti2rw6jzr3">
        <div className="space-y-4" data-id="element-232" data-mp="hhty62n9woae">
          {transformationRows.map((row, i) => <m.div key={row.title} initial={{
          opacity: 0,
          y: 14
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i * 0.08
        }} className="rounded-2xl border border-gris-claro bg-bg-secondary p-5 sm:p-6" data-id="element-233" data-mp="27ui0j41mekg8" data-mpi={i}>
              <p className="mb-3 text-xs font-semibold uppercase tracking-wider text-muted" data-id="element-234" data-mp="3ft5kxq7dpcs3">
                {row.title} · {row.n}
              </p>
              <div className="grid gap-4 sm:grid-cols-2" data-id="element-235" data-mp="36ubsmc12z8kc">
                <div className="flex items-start gap-3" data-id="element-236" data-mp="36vvb89a7lvpa">
                  <div className="mt-0.5 flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-rojo/15" data-id="element-237" data-mp="7dlvz3dqqgiu">
                    <XIcon size={14} className="text-rojo" data-id="element-238" data-mp="3dlhxjuk07cb" />
                  </div>
                  <div data-id="element-239" data-mp="3uqg6xthne122">
                    <p className="text-xs font-semibold uppercase tracking-wide text-rojo" data-id="element-240" data-mp="3upwq6g3qhipm">Antes</p>
                    <p className="mt-1 text-sm leading-relaxed text-muted" data-id="element-241" data-mp="3psee4guf6nde">{row.before}</p>
                  </div>
                </div>
                <div className="flex items-start gap-3" data-id="element-242" data-mp="mc7ld5djmaje">
                  <div className="mt-0.5 flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-success/15" data-id="element-243" data-mp="mamp9bbkyjjf">
                    <CheckIcon size={14} className="text-success" data-id="element-244" data-mp="tpf31hqmnuhy" />
                  </div>
                  <div data-id="element-245" data-mp="yo08bvkql4d9">
                    <p className="text-xs font-semibold uppercase tracking-wide text-success" data-id="element-246" data-mp="13li5yptazx5y">Ahora</p>
                    <p className="mt-1 text-sm leading-relaxed text-gris-oscuro" data-id="element-247" data-mp="17nd6hs3eu6io">{row.after}</p>
                  </div>
                </div>
              </div>
            </m.div>)}
        </div>

        <div className="mt-8 flex justify-center" data-id="element-248" data-mp="1hkhtfu52y60j">
          <PrimaryButton onClick={() => scrollToId('oferta-base')} data-id="element-249" data-mp="1hj6pnubmwy9f">Quiero dejar de improvisar</PrimaryButton>
        </div>

        <div className="mt-8" data-id="element-250" data-mp="1rauowhefnjlg">
          <ScrollHintTable minWidth="480px" data-id="element-251" data-mp="1rb45xfhi2gf0">
            <div className="grid grid-cols-3 divide-x divide-gris-claro bg-white" data-id="element-252" data-mp="1rcxckus450n0">
              {transformationFooterStats.map(stat => <div key={stat.label} className="flex flex-col items-center gap-1 px-3 py-6 text-center" data-id="element-253" data-mp="20azm5ypwx1lw">
                  <span className="font-heading text-xl font-bold text-naranja sm:text-2xl" data-id="element-254" data-mp="1mo0j0fqom6lf">{stat.value}</span>
                  <span className="text-xs text-muted sm:text-sm" data-id="element-255" data-mp="1im5n5qrislf1">{stat.label}</span>
                </div>)}
            </div>
          </ScrollHintTable>
        </div>
      </div>
    </section>;
}